import { LocationNumbersService } from '../../../services'

const purchaseNumber = async function ({ commit, dispatch, state }, config) {
  const { locationId, payload } = config

  try {
    const data = await LocationNumbersService.setPurchaseNumber(
      locationId,
      payload
    )

    await dispatch('fetchLocationTwilio', locationId)
    await commit('resetPhoneNumbersPaginated', {
      page: null
    })
    await dispatch('fetchPhoneNumbersFromDBPaginated', {
      companyId: state.company?.company?.id,
      locationId: locationId,
      getPaginatedDataOnly: false,
      payload: {
        limit: state.table?.limit,
        page: 1,
        query: '',
      }
    })

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default purchaseNumber
